const JUMP_VEL = 1400;
const GRAVITY = 3000;

const STATE_WAIT = 0;
const STATE_ENTER = 1;
const STATE_RUN = 2;
const STATE_EXIT = 3;

export default class Villain extends Phaser.Group {
  constructor(game, x, y, canBeCaught, timeToCatch, levelHeight) {
    super(game);

    //
    this.ANIM_RUN = 'run';
    this.ANIM_JUMP = 'jump';

    this.x = x;
    this.m_posY = this.groundY = y;
    this.canBeCaught = canBeCaught;
    this.timeToCatch = timeToCatch;
    this.time = 0;
    this.levelHeight = levelHeight;
    this.onPositionToCatch = false;
    this.m_onGround = false;

    this.m_speedX = 700;
    this.m_speedY = 0;

    this.m_animId = '';

    this.m_asset = this.game.make.sprite(0, 45, 'chasegame_char_villain');
    this.m_asset.anchor.set(0.5, 1);

    this.state = STATE_ENTER;

    let frames = Phaser.Animation.generateFrameNames('run_', 1, 16, '', 4);
    this.m_asset.animations.add('run', frames, 24, true, false);
    this.m_asset.animations.add('jump', ['run_0008'], 24, false, false);
    this.addChild(this.m_asset);

    this.setAnim(this.ANIM_RUN);
  }

  destroy() {
    this.m_asset.animations.stop();
    this.m_asset = null;
    super.destroy();
  }

  pause() {
    this.m_asset.animations.paused = true;
  }

  resume() {
    this.m_asset.animations.paused = false;
  }

  setAnim(animId) {
    if (this.m_animId != animId) {
      this.m_animId = animId;
      this.m_asset.play(animId);
    }
  }

  exit() {
    this.state = STATE_EXIT;
  }

  step(dt, obstacles) {
    //
    switch (this.state) {
      case STATE_ENTER:
        this.x += this.m_speedX * dt;
        if (this.x > 800) {
          this.x = 800;
          this.state = STATE_RUN;
        }
        break;

      case STATE_RUN:
        if (this.canBeCaught) {
          this.time += dt;
          let factor = 1 - Math.min(1, this.time / this.timeToCatch);
          this.x = 500 + factor * 300;
          this.onPositionToCatch = this.time > this.timeToCatch;
        }
        break;

      case STATE_EXIT:
        this.x += this.m_speedX * dt;
        if (this.x > this.game.defaultWidth + 200) {
          this.state = STATE_WAIT;
        }
        break;
    }

    //gravity
    if (this.m_speedY > -1000) {
      this.m_speedY -= GRAVITY * dt;
    }

    // check ground
    this.m_posY += this.m_speedY * dt;
    if (this.m_posY < this.groundY) {
      if (!this.m_onGround) {
        this.game.sounds.playSpriteSFX('monster_growl', {
          spriteID: 'game_audiosprite',
          volume: 0.7,
        });
      }
      this.m_posY = this.groundY;
      this.m_onGround = true;
      this.m_speedY = 0;

      this.setAnim(this.ANIM_RUN);
    }
    // check for jump
    if (this.state == STATE_RUN) {
      for (let i = 0; i < obstacles.length; i++) {
        let obst = obstacles[i];
        let dist = obst.x - this.x;
        if (!obst.wasJumpedOver && dist < obst.jumpDistance) {
          obst.wasJumpedOver = true;
          this.jump();
        }
      }
    }

    //
    this.y = this.levelHeight - this.m_posY;

    // shadow
    let factor = 1 - Math.min(1, Math.abs((this.m_posY - this.groundY) / 200));
    this.shadow.scale.set(factor);
    this.shadow.alpha = factor;
    this.shadow.x = this.x;
    this.shadow.y = this.levelHeight - this.groundY;
  }

  jump() {
    this.game.sounds.stopSFX('monster_growl', { spriteID: 'game_audiosprite' });
    this.m_speedY = JUMP_VEL;
    this.m_onGround = false;
    this.setAnim(this.ANIM_JUMP);
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/objects/Villain.js